import React from 'react';
import { Card } from 'primereact/card';

export default function OrdersHistoryPage() {
  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ marginTop: 0 }}>Orders History</h2>
      <Card className="cyber-card">
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          <li>#ORD-080 - Completed yesterday</li>
          <li>#ORD-079 - Completed yesterday</li>
          <li>#ORD-078 - Completed 2 days ago</li>
        </ul>
      </Card>
    </div>
  );
}